import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth-context.jsx';
import { supabase } from '../lib/supabase.js';

export default function AppShell() {
  const { email } = useAuth();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    window.location.href = '/login';
  };

  return (
    <div style={shell}>
      <aside style={nav}>
        <div style={brand}>
          <span style={brandWord}>PAR Margin</span>
          <span style={brandTag}>Console</span>
        </div>

        <nav style={navLinks}>
          <NavItem to="/engagements">Engagements</NavItem>
          <NavItem to="/questions">Questions</NavItem>
          <NavItem to="/analytics">Analytics</NavItem>
          <NavItem to="/case-studies">Case studies</NavItem>
          <NavItem to="/settings">Settings</NavItem>
        </nav>

        <div style={navFoot}>
          <div style={{ fontSize: 11, color: 'var(--text-3)', marginBottom: 6, letterSpacing: '0.04em' }}>
            Signed in as
          </div>
          <div style={{ fontSize: 13, color: 'var(--text-1)', marginBottom: 12, wordBreak: 'break-all' }}>
            {email}
          </div>
          <button onClick={handleSignOut} style={signOutBtn}>Sign out</button>
        </div>
      </aside>

      <main style={main}>
        <Outlet />
      </main>
    </div>
  );
}

function NavItem({ to, children }) {
  const loc = useLocation();
  const active = loc.pathname === to || loc.pathname.startsWith(to + '/');
  return (
    <NavLink
      to={to}
      style={{
        ...navItem,
        ...(active ? navItemActive : {}),
      }}
    >
      {children}
    </NavLink>
  );
}

const shell = {
  display: 'flex',
  minHeight: '100vh',
};
const nav = {
  width: 'var(--nav-width)',
  borderRight: '1px solid var(--border-1)',
  background: 'var(--bg-1)',
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 0',
};
const brand = {
  padding: '0 20px 20px',
  borderBottom: '1px solid var(--border-1)',
  marginBottom: 16,
};
const brandWord = {
  display: 'block',
  fontSize: 15,
  fontWeight: 600,
  letterSpacing: '-0.005em',
  color: 'var(--text-0)',
};
const brandTag = {
  fontSize: 10,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: 'var(--accent)',
  fontWeight: 500,
};
const navLinks = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: '0 12px',
  flex: 1,
};
const navItem = {
  display: 'block',
  padding: '8px 12px',
  fontSize: 13,
  color: 'var(--text-2)',
  borderRadius: 'var(--radius-md)',
  transition: 'background 0.1s, color 0.1s',
};
const navItemActive = {
  background: 'var(--bg-2)',
  color: 'var(--text-0)',
};
const navFoot = {
  padding: '20px',
  borderTop: '1px solid var(--border-1)',
};
const signOutBtn = {
  fontSize: 12,
  color: 'var(--text-2)',
  padding: '6px 10px',
  border: '1px solid var(--border-1)',
  borderRadius: 'var(--radius-sm)',
  letterSpacing: '0.02em',
};
const main = {
  flex: 1,
  minWidth: 0,
  background: 'var(--bg-0)',
};
